import { Inject, Injectable } from "@angular/core";
import { map, mergeMap, Observable } from "rxjs";
import { API_ENDPOINT_RESOLVER, IApiEndpointResolver } from "@mobile-data-access-resolvers";
import { HttpClient } from "@angular/common/http";
import { IApiResult } from "@shared-interfaces";
import { IRadiationService } from "./radiation-service.interface";
import { RadiationArticleCodes, RadiationControlCodes } from "@mobile-data-access-enums";
import { IArticle } from "@mobile-data-access-interfaces";

@Injectable()
export class RadiationService implements IRadiationService {
  //#region Constructor

  public constructor(
    @Inject(API_ENDPOINT_RESOLVER)
    protected readonly _apiEndpointResolver: IApiEndpointResolver,
    protected readonly _httpClient: HttpClient
  ) {}

  //#endregion

  //#region Chemo

  public getChemoAsync<T>(id: string, code: RadiationControlCodes): Observable<T> {
    return this._getDataAsync<T>(code, id);
  }

  public getRelatedTopicDetailAsync(id: string): Observable<IArticle> {
    return this._getDataAsync<IArticle>(RadiationArticleCodes.RELATED_TOPIC, id);
  }

  public getWhatNextDetailAsync(id: string): Observable<IArticle> {
    return this._getDataAsync<IArticle>(RadiationArticleCodes.WHAT_NEXT, id);
  }

  //#endregion Chemo

  //#region Internal methods

  protected _getDataAsync<T>(controlCode: string, id: string): Observable<T> {
    return this._getUrlAsync(`radiation/detail/${controlCode}`).pipe(
      mergeMap((apiUrl) => {
        const httpParams: Record<string, string> = {};
        httpParams["id"] = id;

        return this._httpClient
          .get<IApiResult<T>>(apiUrl, { params: httpParams })
          .pipe(map(({ data }) => data));
      })
    );
  }

  protected _getUrlAsync(suffix: string): Observable<string> {
    return this._apiEndpointResolver.loadEndPointAsync("", "").pipe(
      map((baseUrl) => {
        return `${baseUrl}/${suffix}`;
      })
    );
  }

  //#endregion
}
